/**
 * Partner Stats Grid Component
 * Displays analytics stats for the partner dashboard
 */
import { Card, CardContent } from '../ui/card';
import { DollarSign, BarChart3, Wallet, Code } from 'lucide-react';

const PartnerStatsGrid = ({ analytics, widgetsCount }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-emerald-500/10">
              <DollarSign className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Volume</p>
              <p className="text-2xl font-bold">${analytics?.total_volume?.toFixed(2) || '0.00'}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-blue-500/10">
              <BarChart3 className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Transactions</p>
              <p className="text-2xl font-bold">{analytics?.total_transactions || 0}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-purple-500/10">
              <Wallet className="w-5 h-5 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Commission Earned</p>
              <p className="text-2xl font-bold">${analytics?.total_commission_earned?.toFixed(2) || '0.00'}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-orange-500/10">
              <Code className="w-5 h-5 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Active Widgets</p>
              <p className="text-2xl font-bold">{widgetsCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PartnerStatsGrid;
